// import { useEffect } from 'react';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { GetCategoriesList } from '@store/INV/Categories/CategoriesSlice';
// import { useTranslation } from 'react-i18next';

// const useGetCategoriesList = () => {
//   const dispatch = useAppDispatch();

//   const { i18n, t } = useTranslation();
//   useEffect(() => {
//     if (CategoriesList?.length === 0) {
//       dispatch(GetCategoriesList());
//     }
//   }, []);
//   const { CategoriesList, loading, error } = useAppSelector(state => state.CategoriesINV);

//   console.log(JSON.stringify(CategoriesList));

//   const CategoriesOptions = CategoriesList?.map(item => ({
//     value: item.id,
//     label: `${i18n.language === 'en' ? item.name : item.name2}`
//   }));

//   const CategoriesOptionsWithAll = [
//     {
//       label: t('جميع الفئــات'),
//       value: 'All'
//     },
//     ...CategoriesOptions
//   ];

//   return { CategoriesList, CategoriesOptionsWithAll, CategoriesOptions, loading, error };
// };

// export default useGetCategoriesList;

import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetCategoriesList } from '@store/INV/Categories/CategoriesSlice';
import { useTranslation } from 'react-i18next';

const useGetCategoriesList = () => {
  const dispatch = useAppDispatch();
  const { i18n, t } = useTranslation();

  const { CategoriesList, loading, error } = useAppSelector(state => state.CategoriesINV);

  useEffect(() => {
    if (CategoriesList?.length === 0) {
      dispatch(GetCategoriesList());
    }
  }, [dispatch, CategoriesList?.length]);

  const CategoriesOptions = CategoriesList?.map(item => ({
    value: item.id,
    label: `${i18n.language === 'en' ? item.name : item.name2}`
  }));

  const CategoriesOptionsWithAll = [
    {
      label: t('جميع الفئــات'),
      value: 'All'
    },
    ...(CategoriesOptions || [])
  ];

  // دالة لتحويل البيانات إلى هيكل شجري
  const convertToTreeData = (): any[] => {
    if (!CategoriesList || CategoriesList.length === 0) return [];

    const map = new Map<string, any>();
    const treeData: any[] = [];

    // أولاً: إنشاء جميع العقد
    CategoriesList.forEach(item => {
      const node: any = {
        title: i18n.language === 'en' ? item.name : item.name2,
        value: item.id,
        key: item.id,
        icon: item.icon,
        children: [],
        description: item.description,

        image: item.image
      };

      map.set(item.id, node);
    });

    // ثانياً: ربط العقد ببعضها بناءً على categoryId
    CategoriesList.forEach(item => {
      const node = map.get(item.id);
      if (!node) return;

      if (item.categoryId === null) {
        // إذا كانت الفئة رئيسية (لا يوجد parent)
        treeData.push(node);
      } else {
        // إذا كانت الفئة فرعية
        const parent = map.get(item.categoryId);
        if (parent) {
          parent.children.push(node);
        } else {
          // في حالة عدم وجود الأب، نضيفها كعقدة رئيسية
          treeData.push(node);
        }
      }
    });

    return treeData;
  };

  const treeCategoriesData = convertToTreeData();

  return {
    CategoriesList,
    CategoriesOptionsWithAll,
    CategoriesOptions,
    treeCategoriesData,
    loading,
    error
  };
};

export default useGetCategoriesList;
